<template>
  <el-dialog
    :visible.sync="visible"
    width="640px"
    :before-close="handleClose"
  >
    <template slot="title">
      <div class="dialog-title">
        <img src="@/assets/images/dk-icon.png" style="color: #1990FF; width: 20px; height: 20px; margin-right: 6px;" />
        <span>打款凭证</span>
      </div>
    </template>

    <div class="report-info">
      <div class="info-row">
        <span class="info-label">报表名</span>
        <span class="info-value">{{ row.fileName || '--' }}</span>
      </div>
    </div>

    <div class="section-title">打款截图</div>
    <div class="proof-images">
      <div class="image-list" v-if="row.paymentVoucherUrls && row.paymentVoucherUrls.length">
        <el-image
          v-for="(img, index) in row.paymentVoucherUrls"
          :key="index"
          class="proof-img"
          fit="contain"
          :src="img"
          :preview-src-list="row.paymentVoucherUrls"
        ></el-image>
      </div>
      <div class="empty-proof" v-else>
        <img src="@/assets/images/default.png" class="empty-icon" />
        <div class="empty-text">暂无打款截图</div>
      </div>
    </div>

    <template slot="footer">
      <el-button @click="handleClose">关 闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'PayProofDialog',
  props: {
    value: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {}
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) },
      imageList () {
        if (this.row && this.row.paymentVoucherUrls && this.row.paymentVoucherUrls.length) {
          return this.row.paymentVoucherUrls
        }
        return []
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.report-info {
  border: 1px solid #e8ecf2;
  border-radius: 6px;
  padding: 14px 20px;
  margin-bottom: 16px;
  background: #fafbfc;
}
.info-row {
  display: flex;
  line-height: 28px;
}
.info-label {
  width: 80px;
  flex-shrink: 0;
  color: #999;
  font-size: 14px;
}
.info-value {
  color: #333;
  font-size: 14px;
  flex: 1;
}
.section-title {
  font-size: 15px;
  color: #333;
  font-weight: 500;
  margin-bottom: 12px;
}
.proof-images {
  min-height: 120px;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.proof-img {
  width: 136px;
  height: 136px;
  border-radius: 6px;
  border: 1px solid #e8ecf2;
  cursor: pointer;
}
.empty-proof {
  text-align: center;
  padding: 32px 0;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
}
.empty-icon {
  width: 48px;
  height: 48px;
  opacity: 0.5;
}
.empty-text {
  font-size: 14px;
  color: #999;
  margin-top: 8px;
}
</style>
